import { VERTICES_PER_TILE } from "../../../three/consts"

// Base elevation constraints from the schema (using Int8 range)
export const ELEVATION_ABSOLUTE_MIN = -7
export const ELEVATION_ABSOLUTE_MAX = 8

// 1 because Int8
export const ELEVATION_STEP = 1

// Elevation difference that causes ridges/steep slopes
export const RIDGE_ELEVATION_DIFFERENCE = 2

// Fallback elevation when value is not specified
export const FALLBACK_ELEVATION = 1

export const ELEVATION_SIZE = (VERTICES_PER_TILE / 10) / 2

export const ELEVATION_LAND_FLOOR_DEFAULT = 2
export const ELEVATION_SHOAL_FLOOR_DEFAULT = 1
export const ELEVATION_RIVER_FLOOR_DEFAULT = -1
export const ELEVATION_LAKE_FLOOR_DEFAULT = -1
export const ELEVATION_SEA_FLOOR_DEFAULT = -2
export const ELEVATION_SWAMP_FLOOR_DEFAULT = -1
export const ELEVATION_MARSH_FLOOR_DEFAULT = -1

export const ELEVATION_WATER_LEVEL_DEFAULT = 0
